export const merchantDocumentsAcceptedFileTypes = [
  'application/pdf',
  'application/msword', // .doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'application/vnd.ms-excel', // .xls
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  'text/csv', // .csv
  'image/jpeg', // .jpeg, .jpg
  'image/png', // .png
  'application/zip' // .zip
];
